import { createAction } from '@ngrx/store';

export const refreshDocuments = createAction('[Documents] Refresh documents');
